import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import styled from "styled-components";

const StyledModalFooterLink = styled.a`
    font-size: 16px;
    line-height: 100%;
    text-decoration: none;
    color: #8a0538;
    &:hover {
        color: #9654ff;
    }
`;

const StyledModalText = styled.h4`
    font-weight: 400;
    font-size: 17px;
    line-height: 150%;
`;

const StyledModalTitle = styled.h4`
    font-weight: 700;
    font-size: 24px;
    line-height: 130%;
    color: #1e1e1e;
`;

const StyledModalHeader = styled(ModalHeader)`
    border-bottom: none;
    padding-top: 15px;
    padding-bottom: 5px;
    .btn-close {
        font-size: 10px;
        &: focus {
            box-shadow: none;
        }
    }
`;

const StyledModalBody = styled(ModalBody)`
    --bs-modal-padding: 25px;
`;

const StyledModalFooter = styled(ModalFooter)`
    border-top: none !important;
    padding: 0, 30px, 30px, 30px;
    justify-content: center;
`;

const StyledModal = styled(Modal)`
    .modal-content {
        border-radius: 24px;
        text-align: center;
        background: #f0f2f2;
        box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
    }
    .modal-width-300 {
        --bs-modal-width: 300px;
    }
    .modal-width-379 {
        --bs-modal-width: 379px;
    }
    .modal-width-600 {
        --bs-modal-width: 600px;
    }
    .modal-width-700 {
        --bs-modal-width: 700px;
    }
    .modal-width-1000 {
        --bs-modal-width: 1000px;
    }
    .modal-width-1200 {
        --bs-modal-width: 1200px;
    }
    .modal-white {
        .modal-content {
            background: #fff !important;
        }
    }
    .modal-radius-8 {
        .modal-content {
            border-radius: 8px !important;
        }
    }
`;

const StyledContainerButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 0;
`;

const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 16px;
    background-color: #f0f2f2;
    th,
    td {
        padding: 8px;
        border: 1px solid #e0e0e0;
        text-align: left;
        font-size: 14px;
        color: #404040;
    }
`;

const StyledTableHead = styled.thead`
    background-color: #e4e4e4;
    th {
        color: #570013;
        font-weight: 600;
        padding: 12px;
    }
`;

export default {
    StyledModal,
    StyledModalText,
    StyledModalTitle,
    StyledModalHeader,
    StyledModalFooter,
    StyledModalFooterLink,
    StyledModalBody,
    StyledContainerButton,
    StyledTable,
    StyledTableHead,
};
